import { render, staticRenderFns } from "./Cyberblade.vue?vue&type=template&id=5c1ecf00&scoped=true"
import script from "./Cyberblade.vue?vue&type=script&lang=ts"
export * from "./Cyberblade.vue?vue&type=script&lang=ts"
import style0 from "./Cyberblade.vue?vue&type=style&index=0&id=5c1ecf00&prod&lang=scss&scoped=true"
import style1 from "./Cyberblade.vue?vue&type=style&index=1&id=5c1ecf00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1ecf00",
  null
  
)

export default component.exports